import React from 'react'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import Colors from '../../../assets/styles/Colors'
import { Scrollbar } from '../../../assets/styles/GlobalStyle'

const BaseModal: React.FC<{
  isOpen: boolean
  onClose: () => void
  children?: React.ReactNode
  showCloseBtn?: boolean
}> = ({ isOpen = false, onClose, children, showCloseBtn = true }) => {
  return isOpen === false ? null : (
    <Wrapper>
      <Scrollbar hideScroll={isOpen} />
      <ShadowBackground onClick={() => onClose()} />
      <Content>
        {showCloseBtn ? (
          <CloseModalBtn onClick={() => onClose()}>
            <CloseIcon />
          </CloseModalBtn>
        ) : null}
        <div>{children}</div>
      </Content>
    </Wrapper>
  )
}

//
const CloseModalBtn = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: 0px;
  background-color: transparent;
  outline: none;
  padding: 10px;
  margin-right: -10px;
  margin-top: -10px;
  svg {
    width: 14px;
    height: 14px;
    color: ${Colors.rollingStone};
  }
  /*  */
  &:hover {
    svg {
      color: ${Colors.primaryBlack};
    }
  }

  ${Responsive.mobile} {
    display: none;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 101;
  ${Responsive.mobile} {
    z-index: 101;
    padding-inline: 25px;
  }
`
const ShadowBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: black;
  opacity: 0.3;
  width: 100%;
  height: 100vh;
`
const Content = styled.div`
  padding: 48px 54px;
  background-color: white;
  z-index: 6;
  border-radius: 8px;
  position: relative;
  max-width: 464px;
  width: 100%;
  /*  */
  ${Responsive.mobile} {
    padding: 48px 20px;
    max-width: unset;
    width: 100%;
  }
`

export default BaseModal
